export class UpdateRolInUserRequest { 
    
    public userName : string="";
    public id_Rol : number=0;
   
}